/**
 * The type of (redux) action which signals that the controller is capturing mouse and keyboard events.
 *
 * {
 *     type: CAPTURE_EVENTS,
 *     isCapturingEvents: boolean
 * }
 */
export const CAPTURE_EVENTS = 'CAPTURE_EVENTS';
/**
 * The type of (redux) action which signals that a remote control active state has changed.
 *
 * {
 *     type: REMOTE_CONTROL_ACTIVE,
 *     active: boolean
 * }
 */
export const REMOTE_CONTROL_ACTIVE = 'REMOTE_CONTROL_ACTIVE';
/**
 * The type of (redux) action which sets the receiver transport object.
 *
 * {
 *     type: SET_RECEIVER_TRANSPORT,
 *     transport: Transport
 * }
 */
export const SET_RECEIVER_TRANSPORT = 'SET_RECEIVER_TRANSPORT';
/**
 * The type of (redux) action which enables the receiver.
 *
 * {
 *     type: SET_RECEIVER_ENABLED,
 *     enabled: boolean
 * }
 */
export const SET_RECEIVER_ENABLED = 'SET_RECEIVER_ENABLED';
/**
 * The type of (redux) action which sets the controller participant on the receiver side.
 * {
 *     type: SET_CONTROLLER,
 *     controller: string
 * }
 */
export const SET_CONTROLLER = 'SET_CONTROLLER';
/**
 * The type of (redux) action which sets the controlled participant on the controller side.
 * {
 *     type: SET_CONTROLLED_PARTICIPANT,
 *     controlled: string
 * }
 */
export const SET_CONTROLLED_PARTICIPANT = 'SET_CONTROLLED_PARTICIPANT';
/**
 * The type of (redux) action which sets the requested participant on the controller side.
 * {
 *     type: SET_REQUESTED_PARTICIPANT,
 *     requestedParticipant: string
 * }
 */
export const SET_REQUESTED_PARTICIPANT = 'SET_REQUESTED_PARTICIPANT';
/**
 * The type of (redux) action which records what the local control agent, if
 * any, reported about this machine.
 *
 * {
 *     type: SET_AGENT_STATE,
 *     connection: IAgentConnection|undefined,
 *     status: AgentStatus
 * }
 */
export const SET_AGENT_STATE = 'SET_AGENT_STATE';
/**
 * The type of (redux) action which signals that the controller has taken hold
 * of the remote machine, or let go of it.
 *
 * Engagement is separate from having permission: a controller with permission
 * still has to click into the shared screen before their keystrokes leave their
 * own machine, and pressing Escape hands the keyboard straight back.
 *
 * {
 *     type: SET_CONTROLLER_ENGAGED,
 *     engaged: boolean
 * }
 */
export const SET_CONTROLLER_ENGAGED = 'SET_CONTROLLER_ENGAGED';
/**
 * The type of (redux) action which records which display the local participant
 * says they are sharing, when the page could not work it out on its own.
 *
 * {
 *     type: SET_CHOSEN_DISPLAY,
 *     displayId: string
 * }
 */
export const SET_CHOSEN_DISPLAY = 'SET_CHOSEN_DISPLAY';
